// this file is generated by tasks/compile-countries.mjs
export const countries = [
    {
        iso: 'AF',
        phoneCode: '+93',
        'de-DE': 'Afghanistan',
        'en-US': 'Afghanistan',
    },
    {
        iso: 'EG',
        phoneCode: '+20',
        'de-DE': 'Ägypten',
        'en-US': 'Egypt',
    },
    {
        iso: 'AX',
        phoneCode: '+358',
        'de-DE': 'Åland',
        'en-US': 'Åland Islands',
    },
    {
        iso: 'AL',
        phoneCode: '+355',
        'de-DE': 'Albanien',
        'en-US': 'Albania',
    },
    {
        iso: 'DZ',
        phoneCode: '+213',
        'de-DE': 'Algerien',
        'en-US': 'Algeria',
    },
    {
        iso: 'AS',
        phoneCode: '+1',
        'de-DE': 'Amerikanisch-Samoa',
        'en-US': 'American Samoa',
    },
    {
        iso: 'VI',
        phoneCode: '+1',
        'de-DE': 'Amerikanische Jungferninseln',
        'en-US': 'U.S. Virgin Islands',
    },
    {
        iso: 'AD',
        phoneCode: '+376',
        'de-DE': 'Andorra',
        'en-US': 'Andorra',
    },
    {
        iso: 'AO',
        phoneCode: '+244',
        'de-DE': 'Angola',
        'en-US': 'Angola',
    },
    {
        iso: 'AI',
        phoneCode: '+1',
        'de-DE': 'Anguilla',
        'en-US': 'Anguilla',
    },
    {
        iso: 'AG',
        phoneCode: '+1',
        'de-DE': 'Antigua und Barbuda',
        'en-US': 'Antigua & Barbuda',
    },
    {
        iso: 'GQ',
        phoneCode: '+240',
        'de-DE': 'Äquatorialguinea',
        'en-US': 'Equatorial Guinea',
    },
    {
        iso: 'AR',
        phoneCode: '+54',
        'de-DE': 'Argentinien',
        'en-US': 'Argentina',
    },
    {
        iso: 'AM',
        phoneCode: '+374',
        'de-DE': 'Armenien',
        'en-US': 'Armenia',
    },
    {
        iso: 'AW',
        phoneCode: '+297',
        'de-DE': 'Aruba',
        'en-US': 'Aruba',
    },
    {
        iso: 'AC',
        phoneCode: '+247',
        'de-DE': 'Ascension',
        'en-US': 'Ascension Island',
    },
    {
        iso: 'AZ',
        phoneCode: '+994',
        'de-DE': 'Aserbaidschan',
        'en-US': 'Azerbaijan',
    },
    {
        iso: 'ET',
        phoneCode: '+251',
        'de-DE': 'Äthiopien',
        'en-US': 'Ethiopia',
    },
    {
        iso: 'AU',
        phoneCode: '+61',
        'de-DE': 'Australien',
        'en-US': 'Australia',
    },
    {
        iso: 'BS',
        phoneCode: '+1',
        'de-DE': 'Bahamas',
        'en-US': 'Bahamas',
    },
    {
        iso: 'BH',
        phoneCode: '+973',
        'de-DE': 'Bahrain',
        'en-US': 'Bahrain',
    },
    {
        iso: 'BD',
        phoneCode: '+880',
        'de-DE': 'Bangladesch',
        'en-US': 'Bangladesh',
    },
    {
        iso: 'BB',
        phoneCode: '+1',
        'de-DE': 'Barbados',
        'en-US': 'Barbados',
    },
    {
        iso: 'BY',
        phoneCode: '+375',
        'de-DE': 'Belarus',
        'en-US': 'Belarus',
    },
    {
        iso: 'BE',
        phoneCode: '+32',
        'de-DE': 'Belgien',
        'en-US': 'Belgium',
    },
    {
        iso: 'BZ',
        phoneCode: '+501',
        'de-DE': 'Belize',
        'en-US': 'Belize',
    },
    {
        iso: 'BJ',
        phoneCode: '+229',
        'de-DE': 'Benin',
        'en-US': 'Benin',
    },
    {
        iso: 'BM',
        phoneCode: '+1',
        'de-DE': 'Bermuda',
        'en-US': 'Bermuda',
    },
    {
        iso: 'BT',
        phoneCode: '+975',
        'de-DE': 'Bhutan',
        'en-US': 'Bhutan',
    },
    {
        iso: 'BO',
        phoneCode: '+591',
        'de-DE': 'Bolivien',
        'en-US': 'Bolivia',
    },
    {
        iso: 'BQ',
        phoneCode: '+599',
        'de-DE': 'Bonaire, Saba und Sint Eustatius',
        'en-US': 'Caribbean Netherlands',
    },
    {
        iso: 'BA',
        phoneCode: '+387',
        'de-DE': 'Bosnien und Herzegowina',
        'en-US': 'Bosnia & Herzegovina',
    },
    {
        iso: 'BW',
        phoneCode: '+267',
        'de-DE': 'Botswana',
        'en-US': 'Botswana',
    },
    {
        iso: 'BR',
        phoneCode: '+55',
        'de-DE': 'Brasilien',
        'en-US': 'Brazil',
    },
    {
        iso: 'VG',
        phoneCode: '+1',
        'de-DE': 'Britische Jungferninseln',
        'en-US': 'British Virgin Islands',
    },
    {
        iso: 'IO',
        phoneCode: '+246',
        'de-DE': 'Britisches Territorium im Indischen Ozean',
        'en-US': 'British Indian Ocean Territory',
    },
    {
        iso: 'BN',
        phoneCode: '+673',
        'de-DE': 'Brunei',
        'en-US': 'Brunei',
    },
    {
        iso: 'BG',
        phoneCode: '+359',
        'de-DE': 'Bulgarien',
        'en-US': 'Bulgaria',
    },
    {
        iso: 'BF',
        phoneCode: '+226',
        'de-DE': 'Burkina Faso',
        'en-US': 'Burkina Faso',
    },
    {
        iso: 'BI',
        phoneCode: '+257',
        'de-DE': 'Burundi',
        'en-US': 'Burundi',
    },
    {
        iso: 'CL',
        phoneCode: '+56',
        'de-DE': 'Chile',
        'en-US': 'Chile',
    },
    {
        iso: 'CK',
        phoneCode: '+682',
        'de-DE': 'Cookinseln',
        'en-US': 'Cook Islands',
    },
    {
        iso: 'CR',
        phoneCode: '+506',
        'de-DE': 'Costa Rica',
        'en-US': 'Costa Rica',
    },
    {
        iso: 'CW',
        phoneCode: '+599',
        'de-DE': 'Curaçao',
        'en-US': 'Curaçao',
    },
    {
        iso: 'DK',
        phoneCode: '+45',
        'de-DE': 'Dänemark',
        'en-US': 'Denmark',
    },
    {
        iso: 'CD',
        phoneCode: '+243',
        'de-DE': 'Demokratische Republik Kongo',
        'en-US': 'Congo - Kinshasa',
    },
    {
        iso: 'DE',
        phoneCode: '+49',
        'de-DE': 'Deutschland',
        'en-US': 'Germany',
    },
    {
        iso: 'DM',
        phoneCode: '+1',
        'de-DE': 'Dominica',
        'en-US': 'Dominica',
    },
    {
        iso: 'DO',
        phoneCode: '+1',
        'de-DE': 'Dominikanische Republik',
        'en-US': 'Dominican Republic',
    },
    {
        iso: 'DJ',
        phoneCode: '+253',
        'de-DE': 'Dschibuti',
        'en-US': 'Djibouti',
    },
    {
        iso: 'EC',
        phoneCode: '+593',
        'de-DE': 'Ecuador',
        'en-US': 'Ecuador',
    },
    {
        iso: 'SV',
        phoneCode: '+503',
        'de-DE': 'El Salvador',
        'en-US': 'El Salvador',
    },
    {
        iso: 'CI',
        phoneCode: '+225',
        'de-DE': "Elfenbeinküste (Côte d'Ivoire)",
        'en-US': 'Côte d’Ivoire',
    },
    {
        iso: 'ER',
        phoneCode: '+291',
        'de-DE': 'Eritrea',
        'en-US': 'Eritrea',
    },
    {
        iso: 'EE',
        phoneCode: '+372',
        'de-DE': 'Estland',
        'en-US': 'Estonia',
    },
    {
        iso: 'SZ',
        phoneCode: '+268',
        'de-DE': 'Eswatini',
        'en-US': 'Eswatini',
    },
    {
        iso: 'FK',
        phoneCode: '+500',
        'de-DE': 'Falklandinseln',
        'en-US': 'Falkland Islands',
    },
    {
        iso: 'FO',
        phoneCode: '+298',
        'de-DE': 'Färöer',
        'en-US': 'Faroe Islands',
    },
    {
        iso: 'FJ',
        phoneCode: '+679',
        'de-DE': 'Fidschi',
        'en-US': 'Fiji',
    },
    {
        iso: 'FI',
        phoneCode: '+358',
        'de-DE': 'Finnland',
        'en-US': 'Finland',
    },
    {
        iso: 'FM',
        phoneCode: '+691',
        'de-DE': 'Föderierte Staaten von Mikronesien',
        'en-US': 'Micronesia',
    },
    {
        iso: 'FR',
        phoneCode: '+33',
        'de-DE': 'Frankreich',
        'en-US': 'France',
    },
    {
        iso: 'GF',
        phoneCode: '+594',
        'de-DE': 'Französisch-Guayana',
        'en-US': 'French Guiana',
    },
    {
        iso: 'PF',
        phoneCode: '+689',
        'de-DE': 'Französisch-Polynesien',
        'en-US': 'French Polynesia',
    },
    {
        iso: 'GA',
        phoneCode: '+241',
        'de-DE': 'Gabun',
        'en-US': 'Gabon',
    },
    {
        iso: 'GM',
        phoneCode: '+220',
        'de-DE': 'Gambia',
        'en-US': 'Gambia',
    },
    {
        iso: 'GE',
        phoneCode: '+995',
        'de-DE': 'Georgien (ohne Abchasien)',
        'en-US': 'Georgia',
    },
    {
        iso: 'GH',
        phoneCode: '+233',
        'de-DE': 'Ghana',
        'en-US': 'Ghana',
    },
    {
        iso: 'GI',
        phoneCode: '+350',
        'de-DE': 'Gibraltar',
        'en-US': 'Gibraltar',
    },
    {
        iso: 'GD',
        phoneCode: '+1',
        'de-DE': 'Grenada',
        'en-US': 'Grenada',
    },
    {
        iso: 'GR',
        phoneCode: '+30',
        'de-DE': 'Griechenland',
        'en-US': 'Greece',
    },
    {
        iso: 'GL',
        phoneCode: '+299',
        'de-DE': 'Grönland',
        'en-US': 'Greenland',
    },
    {
        iso: 'GB',
        phoneCode: '+44',
        'de-DE': 'Großbritannien',
        'en-US': 'United Kingdom',
    },
    {
        iso: 'GP',
        phoneCode: '+590',
        'de-DE': 'Guadeloupe',
        'en-US': 'Guadeloupe',
    },
    {
        iso: 'GU',
        phoneCode: '+1',
        'de-DE': 'Guam',
        'en-US': 'Guam',
    },
    {
        iso: 'GT',
        phoneCode: '+502',
        'de-DE': 'Guatemala',
        'en-US': 'Guatemala',
    },
    {
        iso: 'GG',
        phoneCode: '+44',
        'de-DE': 'Guernsey (Kanalinsel)',
        'en-US': 'Guernsey',
    },
    {
        iso: 'GN',
        phoneCode: '+224',
        'de-DE': 'Guinea',
        'en-US': 'Guinea',
    },
    {
        iso: 'GW',
        phoneCode: '+245',
        'de-DE': 'Guinea-Bissau',
        'en-US': 'Guinea-Bissau',
    },
    {
        iso: 'GY',
        phoneCode: '+592',
        'de-DE': 'Guyana',
        'en-US': 'Guyana',
    },
    {
        iso: 'HT',
        phoneCode: '+509',
        'de-DE': 'Haiti',
        'en-US': 'Haiti',
    },
    {
        iso: 'HN',
        phoneCode: '+504',
        'de-DE': 'Honduras',
        'en-US': 'Honduras',
    },
    {
        iso: 'HK',
        phoneCode: '+852',
        'de-DE': 'Hongkong',
        'en-US': 'Hong Kong SAR China',
    },
    {
        iso: 'IN',
        phoneCode: '+91',
        'de-DE': 'Indien',
        'en-US': 'India',
    },
    {
        iso: 'ID',
        phoneCode: '+62',
        'de-DE': 'Indonesien',
        'en-US': 'Indonesia',
    },
    {
        iso: 'IM',
        phoneCode: '+44',
        'de-DE': 'Isle of Man',
        'en-US': 'Isle of Man',
    },
    {
        iso: 'IQ',
        phoneCode: '+964',
        'de-DE': 'Irak',
        'en-US': 'Iraq',
    },
    {
        iso: 'IR',
        phoneCode: '+98',
        'de-DE': 'Iran',
        'en-US': 'Iran',
    },
    {
        iso: 'IE',
        phoneCode: '+353',
        'de-DE': 'Irland',
        'en-US': 'Ireland',
    },
    {
        iso: 'IS',
        phoneCode: '+354',
        'de-DE': 'Island',
        'en-US': 'Iceland',
    },
    {
        iso: 'IL',
        phoneCode: '+972',
        'de-DE': 'Israel',
        'en-US': 'Israel',
    },
    {
        iso: 'IT',
        phoneCode: '+39',
        'de-DE': 'Italien',
        'en-US': 'Italy',
    },
    {
        iso: 'JM',
        phoneCode: '+1',
        'de-DE': 'Jamaika',
        'en-US': 'Jamaica',
    },
    {
        iso: 'JP',
        phoneCode: '+81',
        'de-DE': 'Japan',
        'en-US': 'Japan',
    },
    {
        iso: 'YE',
        phoneCode: '+967',
        'de-DE': 'Jemen',
        'en-US': 'Yemen',
    },
    {
        iso: 'JE',
        phoneCode: '+44',
        'de-DE': 'Jersey (Kanalinsel)',
        'en-US': 'Jersey',
    },
    {
        iso: 'JO',
        phoneCode: '+962',
        'de-DE': 'Jordanien',
        'en-US': 'Jordan',
    },
    {
        iso: 'KY',
        phoneCode: '+1',
        'de-DE': 'Kaimaninseln',
        'en-US': 'Cayman Islands',
    },
    {
        iso: 'KH',
        phoneCode: '+855',
        'de-DE': 'Kambodscha',
        'en-US': 'Cambodia',
    },
    {
        iso: 'CM',
        phoneCode: '+237',
        'de-DE': 'Kamerun',
        'en-US': 'Cameroon',
    },
    {
        iso: 'CA',
        phoneCode: '+1',
        'de-DE': 'Kanada',
        'en-US': 'Canada',
    },
    {
        iso: 'CV',
        phoneCode: '+238',
        'de-DE': 'Kap Verde',
        'en-US': 'Cape Verde',
    },
    {
        iso: 'KZ',
        phoneCode: '+7',
        'de-DE': 'Kasachstan',
        'en-US': 'Kazakhstan',
    },
    {
        iso: 'QA',
        phoneCode: '+974',
        'de-DE': 'Katar',
        'en-US': 'Qatar',
    },
    {
        iso: 'KE',
        phoneCode: '+254',
        'de-DE': 'Kenia',
        'en-US': 'Kenya',
    },
    {
        iso: 'KG',
        phoneCode: '+996',
        'de-DE': 'Kirgisistan',
        'en-US': 'Kyrgyzstan',
    },
    {
        iso: 'KI',
        phoneCode: '+686',
        'de-DE': 'Kiribati (Gilbertinseln)',
        'en-US': 'Kiribati',
    },
    {
        iso: 'CC',
        phoneCode: '+61',
        'de-DE': 'Kokosinseln',
        'en-US': 'Cocos (Keeling) Islands',
    },
    {
        iso: 'CO',
        phoneCode: '+57',
        'de-DE': 'Kolumbien',
        'en-US': 'Colombia',
    },
    {
        iso: 'KM',
        phoneCode: '+269',
        'de-DE': 'Komoren',
        'en-US': 'Comoros',
    },
    {
        iso: 'XK',
        phoneCode: '+383',
        'de-DE': 'Kosovo',
        'en-US': 'Kosovo',
    },
    {
        iso: 'HR',
        phoneCode: '+385',
        'de-DE': 'Kroatien',
        'en-US': 'Croatia',
    },
    {
        iso: 'CU',
        phoneCode: '+53',
        'de-DE': 'Kuba',
        'en-US': 'Cuba',
    },
    {
        iso: 'KW',
        phoneCode: '+965',
        'de-DE': 'Kuwait',
        'en-US': 'Kuwait',
    },
    {
        iso: 'LA',
        phoneCode: '+856',
        'de-DE': 'Laos',
        'en-US': 'Laos',
    },
    {
        iso: 'LS',
        phoneCode: '+266',
        'de-DE': 'Lesotho',
        'en-US': 'Lesotho',
    },
    {
        iso: 'LV',
        phoneCode: '+371',
        'de-DE': 'Lettland',
        'en-US': 'Latvia',
    },
    {
        iso: 'LB',
        phoneCode: '+961',
        'de-DE': 'Libanon',
        'en-US': 'Lebanon',
    },
    {
        iso: 'LR',
        phoneCode: '+231',
        'de-DE': 'Liberia',
        'en-US': 'Liberia',
    },
    {
        iso: 'LY',
        phoneCode: '+218',
        'de-DE': 'Libyen',
        'en-US': 'Libya',
    },
    {
        iso: 'LI',
        phoneCode: '+423',
        'de-DE': 'Liechtenstein',
        'en-US': 'Liechtenstein',
    },
    {
        iso: 'LT',
        phoneCode: '+370',
        'de-DE': 'Litauen',
        'en-US': 'Lithuania',
    },
    {
        iso: 'LU',
        phoneCode: '+352',
        'de-DE': 'Luxemburg',
        'en-US': 'Luxembourg',
    },
    {
        iso: 'MO',
        phoneCode: '+853',
        'de-DE': 'Macau',
        'en-US': 'Macao SAR China',
    },
    {
        iso: 'MG',
        phoneCode: '+261',
        'de-DE': 'Madagaskar',
        'en-US': 'Madagascar',
    },
    {
        iso: 'MW',
        phoneCode: '+265',
        'de-DE': 'Malawi',
        'en-US': 'Malawi',
    },
    {
        iso: 'MY',
        phoneCode: '+60',
        'de-DE': 'Malaysia',
        'en-US': 'Malaysia',
    },
    {
        iso: 'MV',
        phoneCode: '+960',
        'de-DE': 'Malediven',
        'en-US': 'Maldives',
    },
    {
        iso: 'ML',
        phoneCode: '+223',
        'de-DE': 'Mali',
        'en-US': 'Mali',
    },
    {
        iso: 'MT',
        phoneCode: '+356',
        'de-DE': 'Malta',
        'en-US': 'Malta',
    },
    {
        iso: 'MA',
        phoneCode: '+212',
        'de-DE': 'Marokko',
        'en-US': 'Morocco',
    },
    {
        iso: 'MH',
        phoneCode: '+692',
        'de-DE': 'Marshallinseln',
        'en-US': 'Marshall Islands',
    },
    {
        iso: 'MQ',
        phoneCode: '+596',
        'de-DE': 'Martinique',
        'en-US': 'Martinique',
    },
    {
        iso: 'MR',
        phoneCode: '+222',
        'de-DE': 'Mauretanien',
        'en-US': 'Mauritania',
    },
    {
        iso: 'MU',
        phoneCode: '+230',
        'de-DE': 'Mauritius',
        'en-US': 'Mauritius',
    },
    {
        iso: 'YT',
        phoneCode: '+262',
        'de-DE': 'Mayotte',
        'en-US': 'Mayotte',
    },
    {
        iso: 'MX',
        phoneCode: '+52',
        'de-DE': 'Mexiko',
        'en-US': 'Mexico',
    },
    {
        iso: 'MD',
        phoneCode: '+373',
        'de-DE': 'Moldau',
        'en-US': 'Moldova',
    },
    {
        iso: 'MC',
        phoneCode: '+377',
        'de-DE': 'Monaco',
        'en-US': 'Monaco',
    },
    {
        iso: 'MN',
        phoneCode: '+976',
        'de-DE': 'Mongolei',
        'en-US': 'Mongolia',
    },
    {
        iso: 'ME',
        phoneCode: '+382',
        'de-DE': 'Montenegro',
        'en-US': 'Montenegro',
    },
    {
        iso: 'MS',
        phoneCode: '+1',
        'de-DE': 'Montserrat',
        'en-US': 'Montserrat',
    },
    {
        iso: 'MZ',
        phoneCode: '+258',
        'de-DE': 'Mosambik',
        'en-US': 'Mozambique',
    },
    {
        iso: 'MM',
        phoneCode: '+95',
        'de-DE': 'Myanmar',
        'en-US': 'Myanmar (Burma)',
    },
    {
        iso: 'NA',
        phoneCode: '+264',
        'de-DE': 'Namibia',
        'en-US': 'Namibia',
    },
    {
        iso: 'NR',
        phoneCode: '+674',
        'de-DE': 'Nauru',
        'en-US': 'Nauru',
    },
    {
        iso: 'NP',
        phoneCode: '+977',
        'de-DE': 'Nepal',
        'en-US': 'Nepal',
    },
    {
        iso: 'NC',
        phoneCode: '+687',
        'de-DE': 'Neukaledonien',
        'en-US': 'New Caledonia',
    },
    {
        iso: 'NZ',
        phoneCode: '+64',
        'de-DE': 'Neuseeland',
        'en-US': 'New Zealand',
    },
    {
        iso: 'NI',
        phoneCode: '+505',
        'de-DE': 'Nicaragua',
        'en-US': 'Nicaragua',
    },
    {
        iso: 'NL',
        phoneCode: '+31',
        'de-DE': 'Niederlande',
        'en-US': 'Netherlands',
    },
    {
        iso: 'NE',
        phoneCode: '+227',
        'de-DE': 'Niger',
        'en-US': 'Niger',
    },
    {
        iso: 'NG',
        phoneCode: '+234',
        'de-DE': 'Nigeria',
        'en-US': 'Nigeria',
    },
    {
        iso: 'NU',
        phoneCode: '+683',
        'de-DE': 'Niue',
        'en-US': 'Niue',
    },
    {
        iso: 'MP',
        phoneCode: '+1',
        'de-DE': 'Nördliche Marianen',
        'en-US': 'Northern Mariana Islands',
    },
    {
        iso: 'KP',
        phoneCode: '+850',
        'de-DE': 'Nordkorea',
        'en-US': 'North Korea',
    },
    {
        iso: 'MK',
        phoneCode: '+389',
        'de-DE': 'Nordmazedonien',
        'en-US': 'North Macedonia',
    },
    {
        iso: 'NF',
        phoneCode: '+672',
        'de-DE': 'Norfolkinsel',
        'en-US': 'Norfolk Island',
    },
    {
        iso: 'NO',
        phoneCode: '+47',
        'de-DE': 'Norwegen',
        'en-US': 'Norway',
    },
    {
        iso: 'OM',
        phoneCode: '+968',
        'de-DE': 'Oman',
        'en-US': 'Oman',
    },
    {
        iso: 'AT',
        phoneCode: '+43',
        'de-DE': 'Österreich',
        'en-US': 'Austria',
    },
    {
        iso: 'TL',
        phoneCode: '+670',
        'de-DE': 'Osttimor',
        'en-US': 'Timor-Leste',
    },
    {
        iso: 'PK',
        phoneCode: '+92',
        'de-DE': 'Pakistan',
        'en-US': 'Pakistan',
    },
    {
        iso: 'PS',
        phoneCode: '+970',
        'de-DE': 'Palästina',
        'en-US': 'Palestinian Territories',
    },
    {
        iso: 'PW',
        phoneCode: '+680',
        'de-DE': 'Palau',
        'en-US': 'Palau',
    },
    {
        iso: 'PA',
        phoneCode: '+507',
        'de-DE': 'Panama',
        'en-US': 'Panama',
    },
    {
        iso: 'PG',
        phoneCode: '+675',
        'de-DE': 'Papua-Neuguinea',
        'en-US': 'Papua New Guinea',
    },
    {
        iso: 'PY',
        phoneCode: '+595',
        'de-DE': 'Paraguay',
        'en-US': 'Paraguay',
    },
    {
        iso: 'PE',
        phoneCode: '+51',
        'de-DE': 'Peru',
        'en-US': 'Peru',
    },
    {
        iso: 'PH',
        phoneCode: '+63',
        'de-DE': 'Philippinen',
        'en-US': 'Philippines',
    },
    {
        iso: 'PL',
        phoneCode: '+48',
        'de-DE': 'Polen',
        'en-US': 'Poland',
    },
    {
        iso: 'PT',
        phoneCode: '+351',
        'de-DE': 'Portugal',
        'en-US': 'Portugal',
    },
    {
        iso: 'PR',
        phoneCode: '+1',
        'de-DE': 'Puerto Rico',
        'en-US': 'Puerto Rico',
    },
    {
        iso: 'CG',
        phoneCode: '+242',
        'de-DE': 'Republik Kongo (Brazzaville)',
        'en-US': 'Congo - Brazzaville',
    },
    {
        iso: 'RE',
        phoneCode: '+262',
        'de-DE': 'Réunion',
        'en-US': 'Réunion',
    },
    {
        iso: 'RW',
        phoneCode: '+250',
        'de-DE': 'Ruanda',
        'en-US': 'Rwanda',
    },
    {
        iso: 'RO',
        phoneCode: '+40',
        'de-DE': 'Rumänien',
        'en-US': 'Romania',
    },
    {
        iso: 'RU',
        phoneCode: '+7',
        'de-DE': 'Russland',
        'en-US': 'Russia',
    },
    {
        iso: 'PM',
        phoneCode: '+508',
        'de-DE': 'Saint-Pierre und Miquelon',
        'en-US': 'St. Pierre & Miquelon',
    },
    {
        iso: 'SB',
        phoneCode: '+677',
        'de-DE': 'Salomonen',
        'en-US': 'Solomon Islands',
    },
    {
        iso: 'BL',
        phoneCode: '+590',
        'de-DE': 'Saint-Barthélemy',
        'en-US': 'St. Barthélemy',
    },
    {
        iso: 'MF',
        phoneCode: '+590',
        'de-DE': 'Saint-Martin (französischer Teil)',
        'en-US': 'St. Martin',
    },
    {
        iso: 'ZM',
        phoneCode: '+260',
        'de-DE': 'Sambia',
        'en-US': 'Zambia',
    },
    {
        iso: 'WS',
        phoneCode: '+685',
        'de-DE': 'Samoa',
        'en-US': 'Samoa',
    },
    {
        iso: 'SM',
        phoneCode: '+378',
        'de-DE': 'San Marino',
        'en-US': 'San Marino',
    },
    {
        iso: 'ST',
        phoneCode: '+239',
        'de-DE': 'São Tomé und Príncipe',
        'en-US': 'São Tomé & Príncipe',
    },
    {
        iso: 'SA',
        phoneCode: '+966',
        'de-DE': 'Saudi-Arabien',
        'en-US': 'Saudi Arabia',
    },
    {
        iso: 'SE',
        phoneCode: '+46',
        'de-DE': 'Schweden',
        'en-US': 'Sweden',
    },
    {
        iso: 'CH',
        phoneCode: '+41',
        'de-DE': 'Schweiz',
        'en-US': 'Switzerland',
    },
    {
        iso: 'SN',
        phoneCode: '+221',
        'de-DE': 'Senegal',
        'en-US': 'Senegal',
    },
    {
        iso: 'RS',
        phoneCode: '+381',
        'de-DE': 'Serbien',
        'en-US': 'Serbia',
    },
    {
        iso: 'SC',
        phoneCode: '+248',
        'de-DE': 'Seychellen',
        'en-US': 'Seychelles',
    },
    {
        iso: 'SL',
        phoneCode: '+232',
        'de-DE': 'Sierra Leone',
        'en-US': 'Sierra Leone',
    },
    {
        iso: 'ZW',
        phoneCode: '+263',
        'de-DE': 'Simbabwe',
        'en-US': 'Zimbabwe',
    },
    {
        iso: 'SG',
        phoneCode: '+65',
        'de-DE': 'Singapur',
        'en-US': 'Singapore',
    },
    {
        iso: 'SX',
        phoneCode: '+1',
        'de-DE': 'Sint Maarten',
        'en-US': 'Sint Maarten',
    },
    {
        iso: 'SK',
        phoneCode: '+421',
        'de-DE': 'Slowakei',
        'en-US': 'Slovakia',
    },
    {
        iso: 'SI',
        phoneCode: '+386',
        'de-DE': 'Slowenien',
        'en-US': 'Slovenia',
    },
    {
        iso: 'SO',
        phoneCode: '+252',
        'de-DE': 'Somalia',
        'en-US': 'Somalia',
    },
    {
        iso: 'ES',
        phoneCode: '+34',
        'de-DE': 'Spanien',
        'en-US': 'Spain',
    },
    {
        iso: 'LK',
        phoneCode: '+94',
        'de-DE': 'Sri Lanka',
        'en-US': 'Sri Lanka',
    },
    {
        iso: 'SH',
        phoneCode: '+290',
        'de-DE': 'St. Helena',
        'en-US': 'St. Helena',
    },
    {
        iso: 'KN',
        phoneCode: '+1',
        'de-DE': 'St. Kitts und Nevis',
        'en-US': 'St. Kitts & Nevis',
    },
    {
        iso: 'LC',
        phoneCode: '+1',
        'de-DE': 'St. Lucia',
        'en-US': 'St. Lucia',
    },
    {
        iso: 'VC',
        phoneCode: '+1',
        'de-DE': 'St. Vincent und die Grenadinen',
        'en-US': 'St. Vincent & Grenadines',
    },
    {
        iso: 'ZA',
        phoneCode: '+27',
        'de-DE': 'Südafrika',
        'en-US': 'South Africa',
    },
    {
        iso: 'SD',
        phoneCode: '+249',
        'de-DE': 'Sudan',
        'en-US': 'Sudan',
    },
    {
        iso: 'KR',
        phoneCode: '+82',
        'de-DE': 'Südkorea',
        'en-US': 'South Korea',
    },
    {
        iso: 'SS',
        phoneCode: '+211',
        'de-DE': 'Südsudan',
        'en-US': 'South Sudan',
    },
    {
        iso: 'SR',
        phoneCode: '+597',
        'de-DE': 'Suriname',
        'en-US': 'Suriname',
    },
    {
        iso: 'SJ',
        phoneCode: '+47',
        'de-DE': 'Spitzbergen und Jan Mayen',
        'en-US': 'Svalbard & Jan Mayen',
    },
    {
        iso: 'SY',
        phoneCode: '+963',
        'de-DE': 'Syrien',
        'en-US': 'Syria',
    },
    {
        iso: 'TJ',
        phoneCode: '+992',
        'de-DE': 'Tadschikistan',
        'en-US': 'Tajikistan',
    },
    {
        iso: 'TW',
        phoneCode: '+886',
        'de-DE': 'Taiwan',
        'en-US': 'Taiwan',
    },
    {
        iso: 'TZ',
        phoneCode: '+255',
        'de-DE': 'Tansania',
        'en-US': 'Tanzania',
    },
    {
        iso: 'TH',
        phoneCode: '+66',
        'de-DE': 'Thailand',
        'en-US': 'Thailand',
    },
    {
        iso: 'TG',
        phoneCode: '+228',
        'de-DE': 'Togo',
        'en-US': 'Togo',
    },
    {
        iso: 'TK',
        phoneCode: '+690',
        'de-DE': 'Tokelau',
        'en-US': 'Tokelau',
    },
    {
        iso: 'TO',
        phoneCode: '+676',
        'de-DE': 'Tonga',
        'en-US': 'Tonga',
    },
    {
        iso: 'TT',
        phoneCode: '+1',
        'de-DE': 'Trinidad und Tobago',
        'en-US': 'Trinidad & Tobago',
    },
    {
        iso: 'TA',
        phoneCode: '+290',
        'de-DE': 'Tristan da Cunha',
        'en-US': 'Tristan da Cunha',
    },
    {
        iso: 'TD',
        phoneCode: '+235',
        'de-DE': 'Tschad',
        'en-US': 'Chad',
    },
    {
        iso: 'CZ',
        phoneCode: '+420',
        'de-DE': 'Tschechien',
        'en-US': 'Czechia',
    },
    {
        iso: 'TN',
        phoneCode: '+216',
        'de-DE': 'Tunesien',
        'en-US': 'Tunisia',
    },
    {
        iso: 'TR',
        phoneCode: '+90',
        'de-DE': 'Türkei',
        'en-US': 'Türkiye',
    },
    {
        iso: 'TM',
        phoneCode: '+993',
        'de-DE': 'Turkmenistan',
        'en-US': 'Turkmenistan',
    },
    {
        iso: 'TC',
        phoneCode: '+1',
        'de-DE': 'Turks- und Caicosinseln',
        'en-US': 'Turks & Caicos Islands',
    },
    {
        iso: 'TV',
        phoneCode: '+688',
        'de-DE': 'Tuvalu (Ellice Islands)',
        'en-US': 'Tuvalu',
    },
    {
        iso: 'UG',
        phoneCode: '+256',
        'de-DE': 'Uganda',
        'en-US': 'Uganda',
    },
    {
        iso: 'UA',
        phoneCode: '+380',
        'de-DE': 'Ukraine',
        'en-US': 'Ukraine',
    },
    {
        iso: 'HU',
        phoneCode: '+36',
        'de-DE': 'Ungarn',
        'en-US': 'Hungary',
    },
    {
        iso: 'UY',
        phoneCode: '+598',
        'de-DE': 'Uruguay',
        'en-US': 'Uruguay',
    },
    {
        iso: 'US',
        phoneCode: '+1',
        'de-DE': 'USA',
        'en-US': 'United States',
    },
    {
        iso: 'UZ',
        phoneCode: '+998',
        'de-DE': 'Usbekistan',
        'en-US': 'Uzbekistan',
    },
    {
        iso: 'VU',
        phoneCode: '+678',
        'de-DE': 'Vanuatu',
        'en-US': 'Vanuatu',
    },
    {
        iso: 'VA',
        phoneCode: '+39',
        'de-DE': 'Vatikanstadt',
        'en-US': 'Vatican City',
    },
    {
        iso: 'VE',
        phoneCode: '+58',
        'de-DE': 'Venezuela',
        'en-US': 'Venezuela',
    },
    {
        iso: 'AE',
        phoneCode: '+971',
        'de-DE': 'Vereinigte Arabische Emirate',
        'en-US': 'United Arab Emirates',
    },
    {
        iso: 'VN',
        phoneCode: '+84',
        'de-DE': 'Vietnam',
        'en-US': 'Vietnam',
    },
    {
        iso: 'CN',
        phoneCode: '+86',
        'de-DE': 'Volksrepublik China',
        'en-US': 'China',
    },
    {
        iso: 'WF',
        phoneCode: '+681',
        'de-DE': 'Wallis und Futuna',
        'en-US': 'Wallis & Futuna',
    },
    {
        iso: 'CX',
        phoneCode: '+61',
        'de-DE': 'Weihnachtsinsel',
        'en-US': 'Christmas Island',
    },
    {
        iso: 'EH',
        phoneCode: '+212',
        'de-DE': 'Westsahara',
        'en-US': 'Western Sahara',
    },
    {
        iso: 'CF',
        phoneCode: '+236',
        'de-DE': 'Zentralafrikanische Republik',
        'en-US': 'Central African Republic',
    },
    {
        iso: 'CY',
        phoneCode: '+357',
        'de-DE': 'Zypern',
        'en-US': 'Cyprus',
    },
];
//# sourceMappingURL=countries.js.map